<header class="flex header">
  <div class="flex gap-[2rem] items-center">
    <h2>
      {{ yarn?.code ? (isReadonly ? ('Yarn_Details_View' | translateWF: 'View') : ('Yarn_Details_Edit' | translateWF: 'Edit')) : ('Yarn_Details_Create' | translateWF: 'Create') }}
    </h2>
  </div>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <loading-overlay [isLoading]="isLoading > 0" />
  @if (yarn?.code) {
    <div class="mb-4">
      <csl-dropdown [enumObject]="statusesEnum" [enumValueOptions]="yarnStatusOptions" [formControl]="status" />
    </div>
  }

  <form [formGroup]="formGroup">
    <div class="grid-12">
      <div class="span-12 form-box">
        <label for="yarnCount">
          {{ 'Yarn_Details_Modal_YarnType' | translateWF: 'Yarn Type' }}
        </label>
        <p-select
          fluid
          id="yarnType"
          formControlName="yarnType"
          class="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty': formGroupSubmitted && formGroup.controls.yarnType.invalid,
          }"
          [options]="_setOptionsForPrimeNg(yarnTypeEnums)"
        />
      </div>
      <div class="span-12 form-box">
        <p-panel [collapsed]="false" [header]="'Yarn_Details_Modal_YarnDescriptionPreview' | translateWF: 'Yarn Description Preview'" [showHeader]="true">
          {{ yarnDescriptionPreview }}
        </p-panel>
      </div>

      <div class="span-12 form-box">
        <label for="yarnCount">
          {{ 'Yarn_Details_Modal_Count' | translateWF: 'Count' }}
        </label>
        <p-inputNumber
          class="w-full"
          id="yarnCount"
          formControlName="yarnCount"
          [ngClass]="{
            'ng-invalid ng-dirty': formGroupSubmitted && formGroup.controls.yarnCount.invalid,
          }"
        ></p-inputNumber>
      </div>

      @if (isStaple) {
        <div class="span-12 form-box">
          <label for="ply">
            {{ 'Yarn_Details_Modal_Ply' | translateWF: 'Ply' }}
          </label>
          <p-inputNumber
            class="w-full"
            id="ply"
            [formControl]="staplePropertiesFormGroup.controls.ply"
            [ngClass]="{
              'ng-invalid ng-dirty': formGroupSubmitted && staplePropertiesFormGroup.controls.ply.invalid,
            }"
          >
          </p-inputNumber>
        </div>

        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_FiberProcessingMethod' | translateWF: 'Fiber Processing Method' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="staplePropertiesFormGroup.controls.fiberProcessingMethodCode"
            categoryCode="FiberProcessingMethod"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_YarnProcessingMethod' | translateWF: 'Yarn Processing Method' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="staplePropertiesFormGroup.controls.stapleYarnProcessingMethodCode"
            categoryCode="StapleYarnProcessingMethod"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_YarnEffect' | translateWF: 'Yarn Effect' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="staplePropertiesFormGroup.controls.yarnEffectCode"
            categoryCode="YarnEffect"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_YarnEndUse' | translateWF: 'Yarn End Use' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="staplePropertiesFormGroup.controls.yarnEndUseCode"
            categoryCode="YarnEndUse"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
      } @else {
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_YarnProcessingMethod' | translateWF: 'Yarn Processing Method' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="filamentPropertiesFormGroup.controls.filamentYarnProcessingMethodCode"
            categoryCode="FilamentYarnProcessingMethod"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_NumberOfFilaments' | translateWF: 'Number of Filaments' }}
          </label>
          <p-inputNumber
            class="w-full"
            id="yarnCount"
            [formControl]="filamentPropertiesFormGroup.controls.numberOfFilaments"
            [ngClass]="{
              'ng-invalid ng-dirty': formGroupSubmitted && filamentPropertiesFormGroup.controls.numberOfFilaments.invalid,
            }"
          ></p-inputNumber>
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_Luster' | translateWF: 'Luster' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="filamentPropertiesFormGroup.controls.yarnLusterCode"
            categoryCode="YarnLuster"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
        <div class="span-12 form-box">
          <label>
            {{ 'Yarn_Details_Modal_InterlacingLevel' | translateWF: 'Interlacing Level' }}
          </label>
          <csl-dropdown-master-data
            class="w-full"
            [formControl]="filamentPropertiesFormGroup.controls.yarnInterlacingLevelCode"
            categoryCode="YarnInterlacingLevel"
            (onDelete)="handleDelete($event)"
            (onUpdate)="handleUpdate($event)"
            (emitMessagesApi)="showMessagesApi($event)"
            (onUpdate)="handleUpdate($event)"
            [allowCreate]="false"
          />
        </div>
      }
    </div>

    <div class="form-box">
      <div class="row-between-center w-full mt-[1rem]">
        <h3>{{ 'Yarn_Details_Composition' | translateWF: 'Composition' }}</h3>
        @if (!isReadonly) {
          <p-button label="{{ 'Yarn_Details_Add_Composition' | translateWF: 'Add Composition' }}" icon="pi pi-plus" variant="outlined" (click)="addComposition()" />
        }
      </div>

      <div class="w-full" formArrayName="compositions">
        <div *ngFor="let composition of compositionsFormArray.controls; let i = index" [formGroupName]="i" class="grid-12 gap-[1rem] mb-2 items-center">
          <div class="span-12">
            <p-autocomplete
              fluid=""
              formControlName="compositionCode"
              [suggestions]="filteredCompositions"
              (completeMethod)="filterCompositions($event)"
              optionValue="code"
              optionLabel="optionLabel"
              [forceSelection]="true"
              [style]="{ width: '100%' }"
              [placeholder]="'Yarn_Details_Select_Composition' | translateWF: 'Select Composition'"
              [dropdown]="true"
            ></p-autocomplete>
          </div>

          <div class="span-10">
            <p-inputNumber class="w-full" formControlName="percentage" [min]="0" [max]="100" [suffix]="'%'" [showButtons]="true" [style]="{ width: '100%' }"></p-inputNumber>
          </div>

          @if (!isReadonly) {
            <div class="span-2 text-center">
              <p-button icon="pi pi-trash" (click)="removeComposition(i)" />
            </div>
          }
        </div>
      </div>

      <!-- Show warning if total is not 100% -->
      <div class="my-6" *ngIf="compositionsFormArray.controls.length > 0">
        <div class="row-between-center">
          <span class="mr-2"
            >{{ 'Yarn_Details_Current_Total' | translateWF: 'Current Total' }}: <strong>{{ getCompositionTotal() }}%</strong></span
          >
          <p-message *ngIf="!validateCompositionTotal()" severity="warn" [text]="'Yarn_Details_Total_Warning' | translateWF: 'Total Warning'"></p-message>
          <p-message *ngIf="validateCompositionTotal()" severity="success" [text]="'Yarn_Details_Total_Success' | translateWF: 'Total Success'"></p-message>
        </div>
      </div>
      <div *ngIf="compositionsFormArray.controls.length === 0" class="text-center mt-8 py-4 bg-gray-100 rounded">
        <p>
          {{ 'Yarn_Details_No_Compositions' | translateWF: 'No Compositions' }}
        </p>
      </div>
    </div>
  </form>
</section>

<footer>
  @if (!isReadonly) {
    <p-button class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" />
  }
  <p-button class="w-full" [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
